import InnerPage from 'components/InnerPage/InnerPage'
import categoryUrl from 'helpers/categoryUrl'
import React, { useEffect, useState } from 'react'
import CategoryService from 'services/CategoryService'
import { pageViewEvent } from 'services/conversionevents'
import ProductService from 'services/ProductService'
import useFilter from 'store/FilterProvider'
import useInnerPage from 'store/InnerPageProvider'

const CategoryPage = props => {
  const { filters } = useFilter()
  const { slug, keyword } = props.match.params
  const [category, setCategory] = useState({})
  const {
    init,
    additionalData,
    setAdditionalData,
    setCategory: setInnerPageCategory,
  } = useInnerPage()

  useEffect(() => {
    init({
      resolver: () =>
        ProductService.getByCategorySlug(slug, {
          keyword: keyword,
        }).then(data => {
          return data
        }),
    })
    startCategoryLoading()
    // clearFilters()
    CategoryService.getCategoryBySlug(slug, filters)
      .then(cat => {
        setInnerPageCategory(cat?.category || {})
        document.title = cat?.category?.meta_title
        setCategory(cat)
        stopCategoryLoading()
        pageViewEvent()
      })
      .catch(() => {
        stopCategoryLoading()
      })
  }, [slug, keyword])

  const startCategoryLoading = () => {
    setAdditionalData({
      ...additionalData,
      categoryPageLoading: true,
    })
  }

  const stopCategoryLoading = () => {
    setAdditionalData({
      ...additionalData,
      categoryPageLoading: false,
    })
  }

  const breadcrumb = [
    { name: 'მთავარი', to: '/', active: false },
    { name: 'კატეგორიები', to: '/all-category' },
    ...(category.parents || []).map(cat => {
      return {
        name: cat.title,
        to: categoryUrl(cat.slug),
      }
    }),
    {
      name: category.category?.title,
      to: categoryUrl(category.slug),
      active: true,
    },
  ]

  if (keyword) {
    breadcrumb.push({
      name: `საძიებო სიტყვა: "${keyword}"`,
      to: '#',
      active: true,
    })
  }

  return (
    <InnerPage
      backLink={categoryUrl(category.parent?.slug || '/')}
      backText={category.parent?.title || 'მთავარი'}
      slug={category.slug}
      breadcrumb={breadcrumb}
      tiles={category.show_only_products ? [] : category.tiles}
      blocks={category.show_only_products ? [] : category.blocks}
      category={category}
    />
  )
}

export default CategoryPage
